import one from '../assets/png/Ass 1.png'
import seven from '../assets/png/Ass 7.png'
import nine from '../assets/png/Ass 9.png'
import ten from '../assets/png/Ass 10.png'
import eleven from '../assets/png/Ass 11.png'
import twleve from '../assets/png/Ass 12.png'



export const projectsData = [
    {
        id: 1,
        projectName: 'Healthy Food Network',
        projectDesc: 'There Have Healthy Food Item & recipy.',
        tags: ['HTML', 'CSS'],
        code: 'https://github.com/MohammadMahbub/Healthy-Food-Network',
        demo: 'https://mohammadmahbub.github.io/Healthy-Food-Network/',
        image: one
    },
    {
        id: 2,
        projectName: 'Nesto Hypermarket E-Commerce',
        projectDesc: 'This Is A Online E-Commerce Shop.',
        tags: ['HTML', 'CSS', 'TAILWIND', 'JS'],
        code: 'https://github.com/MohammadMahbub/ranga-store-fix-Mahbub1996',
        demo: 'https://nesto-hypermarket.netlify.app/',
        image: seven
    },
    {
        id: 3,
        projectName: 'Digital Online School',
        projectDesc: 'Digital Online School Have Online Class System & Another Subject Enrole System.',
        tags: ['HTML', 'CSS', 'REACT-BOOTSTRAP', 'JS', 'RECAT'],
        code: 'https://github.com/MohammadMahbub/review-website-Mahbub1996',
        demo: 'https://digital-online-school.netlify.app/',
        image: nine
    },
    {
        id: 4,
        projectName: 'Oreo Hospital',
        projectDesc: 'Welcome to Oreo Hospital. Oreo Hospital is a leading multi-speciality hospital offering best in class medical services. The 100 beded multi speciality',
        tags: ['HTML', 'CSS', 'REACT-BOOTSTRAP', 'JS', 'RECAT', 'FIREBASE'],
        code: 'https://github.com/Programming-Hero-Web-Course3/healthcare-related-website-Mahbub1996',
        demo: 'https://dental-care-5ad47.web.app/',
        image: ten
    },
    {
        id: 5,
        projectName: 'Travel Agency',
        projectDesc: 'A Simple Travel Agency application',
        tags: ['HTML', 'CSS', 'REACT-BOOTSTRAP', 'JS', 'RECAT', 'FIREBASE'],
        code: 'https://github.com/programming-hero-web-course1/tourism-or-delivery-website-client-side-Mahbub1996',
        demo: 'https://travel-agency-35c03.web.app/',
        image: eleven
    },
    {
        id: 6,
        projectName: 'Grand Prix',
        projectDesc: 'E-CPMMERCE MOTOR BICK SHOP',
        tags: ['HTML', 'CSS', 'MATERIAL-UI', 'JS', 'RECAT', 'FIREBASE'],
        code: 'https://github.com/programming-hero-web-course-4/niche-website-client-side-Mahbub1996',
        demo: 'https://grand-motor.web.app/',
        image: twleve
    },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/MohammadMahbub',
    //     demo: 'https://github.com/MohammadMahbub',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/MohammadMahbub',
    //     demo: 'https://github.com/MohammadMahbub',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/